import { ContentTopInfoBox } from './content/top-info-box';
import { File } from './file';
import { InternGenericComparisonFeature } from './intern/generic-comparison-feature';
import { InternGenericComparisonPrice } from './intern/generic-comparison-price';
import { InternLink } from './intern/link';

/**
 * Model definition for Generic Comparison Entry
 */
export interface GenericComparisonEntry {
  __contentType: 'generic-comparison-entry';
  id: string;
  name?: string;
  headline?: string;
  text?: string;
  subline?: string;
  features?: InternGenericComparisonFeature[];
  benefits?: ContentTopInfoBox;
  image?: File;
  recommendation?: boolean | null;
  link?: InternLink;
  price?: InternGenericComparisonPrice;
}

export function isGenericComparisonEntry(obj: { __contentType?: string }): obj is GenericComparisonEntry {
  return obj.__contentType === 'generic-comparison-entry';
}
